import * as React from 'react';
import {
    Table,
    Button,
    FormControl,
    Checkbox,
    HelpBlock,
    FormGroup,
    ControlLabel,
    Collapse,
    Row,
    Col
} from 'react-bootstrap';
import { Translate } from '../../../shared/LanguageService';
import FormInputChangeHandler from '../../../shared/form/FormInputChangeHandler';
import FormValidationService from '../../../shared/form/FormValidationService';
import { assign } from '../../../shared/Assign';
import FormSelect from '../../../components/common/FormSelect';
import {useState} from "react";

class OrderSourcesList extends React.Component<any, any> {
    selectedOrderSourceIdChangeHandler: FormInputChangeHandler;
    firmIdChangeHandler: FormInputChangeHandler;
    constructor(props: any, context: any) {
        super(props, context);
        
        this.state = {
            selectedOrderSourceId: 0,
            firmId: '',
            availableOrderSources: [],
        };
        
        this.add = this.add.bind(this);
        this.remove = this.remove.bind(this);
        
        this.selectedOrderSourceIdChangeHandler = new FormInputChangeHandler(
            this.state,
            (newState) =>
                this.setState({
                    selectedOrderSourceId: newState.selectedOrderSourceId
                })
        );
        this.firmIdChangeHandler = new FormInputChangeHandler(
            this.state, 
            (newState) => {
            this.setState({ 
                firmId: newState.firmId 
            });
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        this.setState({
            availableOrderSources: nextProps.availableOrderSources
        });
    }

    remove(e: any, item: any) {
        e.stopPropagation();
        let orderSources = assign([], this.props.orderSources);
        let index = orderSources.findIndex(
            (x: any) => x.contentProviderId === item.contentProviderId
        ) ;
        orderSources.splice(index, 1);
        this.props.update(orderSources);
    }

    add() {
        let selected = {
            contentProviderId: this.state.selectedOrderSourceId,
            firmId: this.state.firmId,
            contentProviderName: this.state.availableOrderSources.find(
                (x: any) => x.id === this.state.selectedOrderSourceId
            ).name
        };

        let orderSources = assign([], this.props.orderSources);
        orderSources.push(selected);
        this.props.update(orderSources);
        this.setState({ firmId: '' });
    }

    isAddButtonDisabled(): boolean {
        return (
            !this.state.selectedOrderSourceId ||
            !this.state.firmId ||
            this.props.orderSources.some(
                (x) =>
                    x.firmId === this.state.firmId &&
                    x.contentProviderId === this.state.selectedOrderSourceId
            )
        );
    }

    render() {
        return (
            <fieldset>
                <legend>{Translate('broker/ordersources/form/title')}</legend>
                <Row>
                    <Col sm={6}>
                        <FormGroup>
                            <ControlLabel>
                                {Translate('broker/ordersources/form/ordersource')}
                            </ControlLabel>
                            <FormSelect
                                name="selectedOrderSourceId"
                                value={
                                    this.state.selectedOrderSourceId
                                        ? this.state.selectedOrderSourceId
                                        : ''
                                }
                                onChange={this.selectedOrderSourceIdChangeHandler.onChange}
                            >
                                <option value="0" key="0">
                                    {Translate(
                                        'broker/ordersources/form/ordersource-default-option'
                                    )}
                                </option>
                                {this.state.availableOrderSources.map((x: any) => (
                                    <option value={x.id} key={x.id}>
                                        {Translate(x.name)}
                                    </option>
                                ))}
                            </FormSelect>
                        </FormGroup>
                    </Col>

                    <Col sm={6}>
                        <FormGroup>
                            <ControlLabel>
                                {Translate('broker/ordersources/form/contentproviderfirmid')}
                            </ControlLabel>
                            <FormControl
                                type="text"
                                name="firmId"
                                placeholder={Translate(
                                    'broker/ordersources/form/firmid-placeholder'
                                )}
                                value={this.state.firmId ? this.state.firmId : ''}
                                onChange={this.firmIdChangeHandler.onChange}
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Button
                    className="pull-right"
                    bsSize="small"
                    bsStyle="success"
                    disabled={this.isAddButtonDisabled()}
                    onClick={this.add}
                >
                    {Translate('broker/ordersources/form/add-button')}{' '}
                    <i className="material-icons">add</i>
                </Button>
                <Table hover responsive className="order-sources-table">
                    <thead>
                        <tr>
                            <th>
                                {Translate('broker/ordersources/table/header/ordersource-name')}
                            </th>
                            <th>
                                {Translate('broker/ordersources/table/header/ordersource-firmId')}
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    {this.props.orderSources.map((x: any) => {
                        return (
                            <tbody key={x.contentProviderId + x.firmId}>
                                <tr>
                                    <td>{Translate(x.contentProviderName)}</td>
                                    <td>{x.firmId}</td>
                                    <td className="tools">
                                        <Button
                                            bsStyle="danger"
                                            bsSize="small"
                                            onClick={(e: any) => this.remove(e, x)}
                                        >
                                            <i className="material-icons">delete_forever</i>
                                        </Button>
                                    </td>
                                </tr>
                            </tbody>
                        );
                    })}
                </Table>

                <Row>
                    <Col sm={6}>
                        <FormGroup>
                            <ControlLabel>
                                {Translate('broker/ordersources/form/archivesource')}
                            </ControlLabel>
                            <FormSelect 
                                name="selectedArchiveSourceId"
                                value={
                                    this.props.archiveSource
                                        ? this.props.archiveSource.value
                                        : 0
                                }
                                onChange={this.props.updateArchiveSource}
                            >
                                <option value="0" key="0">
                                        {Translate('broker/ordersources/form/archivesource-default-option')}
                                </option>
                                {this.props.availableArchiveSources.map((x: any) => (
                                    <option value={x.value} key={x.value}>
                                       {Translate(x.displayName)}
                                    </option>
                                ))}
                            </FormSelect>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6}>
                        <FormGroup>
                            <ControlLabel>
                                {Translate('broker/ordersources/form/ProcountorId')}
                            </ControlLabel>
                            <FormControl
                                type="text"
                                name="procountorId"
                                maxLength={40}
                                value = {this.props.procountorId ? this.props.procountorId : ''}
                                onChange = {this.props.onChange}
                            >

                            </FormControl>
                        </FormGroup>
                    </Col>
                </Row>
                
            </fieldset>
        );
    }
}

export default OrderSourcesList;
